import React from "react";
import connect from "Shared/connect";
import Button from "Shared/Button";
import Icon from "Shared/Icon";
import classnames from "classnames";
import * as styles from "./base.scss";
import { toggleRightMenu } from "SiteLayout/RightMenu/action-creators";
function HamburgerButton(props) {
    return (React.createElement(Button, { type: "button", className: classnames(styles.menu, {
            [styles.open]: props.isOpen,
        }), onClick: props.toggleRightMenu },
        React.createElement("span", { className: styles.nav },
            React.createElement(Icon, { name: "nav" })),
        React.createElement("span", { className: styles.close },
            React.createElement(Icon, { name: "close" }))));
}
export default connect((state) => ({
    isOpen: state.mainMenu.rightMenuIsOpen,
}), (dispatch) => ({
    toggleRightMenu: (e) => {
        dispatch(toggleRightMenu());
    },
}))(HamburgerButton);
